import { create, all } from 'mathjs'

const config = {
  number: 'BigNumber',
}
export const bigmath = create(all, config)
/**
 * @method round(value,decimals)  四舍五入到最接近的整数
 * @method hasNumericValue(x)  Test whether a value is an numeric value.
 * @method isInteger(x)  Test whether a value is an integer number.
 * @method isNaN(x)  Test whether a value is NaN (not a number).
 * @method isNegative(x) Test whether a value is negative: smaller than zero.
 * @method isNumeric(x)  Test whether a value is an numeric value.
 * @method isPositive(x) Test whether a value is positive: larger than zero.
 * ... https://mathjs.org/docs/reference/functions.html
 */

/**
 * 转换为数字, 无数字则返回0
 */
export const bNumber = (value) => {
  if (bigmath.hasNumericValue(value) === false
    || bigmath.isNaN(value) === true
    || Number.isFinite(Number(value)) === false
  ) {
    value = 0;
  }
  return bigmath.numeric(value, 'BigNumber').toNumber();
};
/**
 * 截断舍入
 * @param value 值
 * @param decimals 保留的小数位数
 */
export const truncate = (value, decimals) => {
  return bigmath.fix(value, decimals);
}
/**
 * 加法
 */
export const add = (...args) => {
  return bigmath.add(...(args.map(x => bigmath.bignumber(x)))).toNumber();
}
/**
 * 减法
 */
export const sub = (...args) => {
  return bigmath.subtract(...(args.map(x => bigmath.bignumber(x)))).toNumber();
}
/**
 * 乘法
 */
export const mul = (...args) => {
  return bigmath.multiply(...(args.map(x => bigmath.bignumber(x)))).toNumber();
}
/**
 * 除法
 * @returns x / y
 */
export const div = (x, y) => {
  return bigmath.divide(bigmath.bignumber(x), bigmath.bignumber(y)).toNumber();
}
/**
 * 算式直接运算
 * 有风险
 * @example calculate('0.1 + 0.2')  // 0.3
 * @returns number
 */
export const calculate = (expr, percision = 2) => truncate(bigmath.evaluate(expr).toNumber(), percision);

